<template>
  <PageHeaderLayout>
    <div class="main-page-content">
      <div class="toolbar">
        <el-form :inline="true" :model="searchCondition" class="search-form">
          <el-form-item label="创建人">
            <el-input
              v-model="searchCondition.user_name"
              placeholder="请输入创建人"
              clearable
              @keyup.enter.native="searchButton"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司名字">
            <el-input
              v-model="searchCondition.company_name"
              placeholder="请输入公司"
              clearable
              @keyup.enter.native="searchButton"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchButton">查询</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>

        <div class="export-actions">
          <MonthPicker @MonthSearch="handleMonthSearch" />
          <el-select v-model="exportType" class="export-type" placeholder="请选择导出类型">
            <el-option
              v-for="item in exportOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button
            icon="el-icon-document"
            :loading="downloadLoading"
            @click="handleDownload"
          >导出</el-button>
        </div>
      </div>

      <el-table
        v-loading="loading"
        :data="list"
        style="width: 100%"
        :header-cell-style="{ background: '#fbfbfb' }"
      >
        <el-table-column prop="company_name" label="公司名称" min-width="220"></el-table-column>
        <el-table-column label="公司税号" min-width="180" align="center">
          <template slot-scope="scope">{{ getAuthValue(scope.row, 'taxpayer') }}</template>
        </el-table-column>
        <el-table-column label="企业电话" min-width="150" align="center">
          <template slot-scope="scope">{{ getAuthValue(scope.row, 'loginAccount') }}</template>
        </el-table-column>
        <el-table-column prop="user_name" label="创建人" min-width="130" align="center"></el-table-column>
        <el-table-column prop="created_at" label="创建时间" min-width="180" align="center"></el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        background
        :current-page="page.current_page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.page_size"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </PageHeaderLayout>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import MonthPicker from '@/components/MonthPicker.vue'

export default {
  name: 'AigcCompany',
  components: {
    PageHeaderLayout,
    MonthPicker
  },
  data() {
    return {
      loading: false,
      downloadLoading: false,
      list: [],
      searchCondition: {
        user_name: '',
        company_name: ''
      },
      exportRange: {
        start_time: '',
        end_time: ''
      },
      exportType: 'xlsx',
      exportOptions: [
        { label: 'xlsx', value: 'xlsx' },
        { label: 'csv', value: 'csv' },
        { label: 'txt', value: 'txt' }
      ],
      page: {
        current_page: 1,
        page_size: 10,
        total: 0
      }
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    searchButton() {
      this.page.current_page = 1
      this.loadList()
    },
    resetSearch() {
      this.searchCondition = {
        user_name: '',
        company_name: ''
      }
      this.searchButton()
    },
    handleMonthSearch(value) {
      this.exportRange.start_time = value && value[0] ? value[0] : ''
      this.exportRange.end_time = value && value[1] ? value[1] : ''
    },
    handleSizeChange(value) {
      this.page.page_size = value
      this.page.current_page = 1
      this.loadList()
    },
    handleCurrentChange(value) {
      this.page.current_page = value
      this.loadList()
    },
    getSearchParams() {
      let params = {}
      if (this.searchCondition.user_name) {
        params.user_name = this.searchCondition.user_name
      }
      if (this.searchCondition.company_name) {
        params.company_name = this.searchCondition.company_name
      }
      return params
    },
    async loadList() {
      this.loading = true
      try {
        let res = await this.$api.getKhlAiOrderAuthCompanyList({
          ...this.getSearchParams(),
          current_page: this.page.current_page,
          page_size: this.page.page_size
        })
        this.list = res.data || []
        this.page = Object.assign({}, this.page, res.pages || {})
      } finally {
        this.loading = false
      }
    },
    getAuthValue(row, key) {
      return row && row.auth_json && row.auth_json[key] ? row.auth_json[key] : '-'
    },
    async handleDownload() {
      this.downloadLoading = true
      try {
        let res = await this.$api.getKhlAiOrderAuthCompanyList({
          ...this.getSearchParams(),
          current_page: 1,
          page_size: 50000
        })
        let list = res.data || []
        if (this.exportRange.start_time && this.exportRange.end_time) {
          list = list.filter(item => {
            return item.created_at >= this.exportRange.start_time &&
              item.created_at <= this.exportRange.end_time
          })
        }
        if (!list.length) {
          this.$message.warning('暂无可导出的数据')
          return
        }
        let excel = await import('@/excel/Export2Excel')
        excel.export_json_to_excel({
          header: ['公司名称', '公司税号', '企业电话', '创建人', '创建时间'],
          data: list.map(item => [
            item.company_name,
            this.getAuthValue(item, 'taxpayer'),
            this.getAuthValue(item, 'loginAccount'),
            item.user_name,
            item.created_at
          ]),
          filename: `AIGC商户${new Date().getTime()}`,
          autoWidth: true,
          bookType: this.exportType
        })
      } finally {
        this.downloadLoading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.main-page-content {
  min-height: calc(100vh - 150px);
  padding: 24px;
  background: #fff;
}

.toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.search-form {
  margin-right: 20px;
}

.export-actions {
  display: flex;
  align-items: flex-start;
}

.export-type {
  width: 120px;
  margin-right: 12px;
}

.pagination {
  margin-top: 24px;
  text-align: right;
}
</style>
